import React from "react";
import moment from "moment";

export const getTodayDate = () => {
  return moment().format("YYYYMMDD");
};

export const getTodayDateWebview = () => {
  return moment().format("DD/MM/YYYY");
};

export const getFileExt = (name) => {
  return name.split(".").pop();
};

export const changeDateFormat = (date) => {
  return moment(date, "YYYYMMDD").format("DD/MM/YYYY");
};

export const dateAddSubstractWebView = (date, type) => {
  if (type == "plus") {
    return moment(date, "DD/MM/YYYY").add(1, "days").format("DD/MM/YYYY");
  } else {
    return moment(date, "DD/MM/YYYY").subtract(1, "days").format("DD/MM/YYYY");
  }
};

export const dateChangeFromatWebView = (date) => {
  return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
};

export const changeDateFormatDateField = (date) => {
  return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
};

export const getLessonByDayAndHour = (h, groups) => {
  return groups.filter((group) => group.slot === h);
};

export const getLessonByDayAndHourAndTeacher = (h, info) => {
  let groupsId = [];
  let currentGroupsByTeacher = info.groups.filter((group) => group.teachers.includes(info.teacherId));
  groupsId = currentGroupsByTeacher.map((group) => group._id);


  let groupsToRerurn = info.ttGroups.filter((group) => {
    return groupsId.includes(group.group_id) && group.slot === h
  });
  //console.log('groupsToRerurn', groupsToRerurn);
  return groupsToRerurn;

};

export const getGroupById = (id, groups) => {
  return groups.filter((group) => {
    return group._id === id;
  });
};

export const getRoomById = (id, rooms) => {
  return rooms.filter((room) => {
    return room._id === id;
  });
};

export const getGroupByClass = (c, groups) => {
  return groups.filter((group) => {
    return group.classes.includes(c);
  });
};

export const getClassHoursById = (state) => {
  let labelToReturn;
  let classNumber = getClassNumberById(state);
  state.slotLabels.forEach(function (element) {
    element.classes.forEach(function (elementInner) {
      if (elementInner.id === classNumber[0]) {
        labelToReturn = element.labels;
      }
    });
  });
  return labelToReturn;
};

export const getClassNumberById = (state) => {
  let classes = state.classes;
  return classes
    .filter((classInfo) => {
      return classInfo._id == state.classId;
    })
    .map(function (classFiltered) {
      return classFiltered.id;
    });
};

// get index by value
export const getIndexByValue = (arr, value) => {
  let indexToReturn;
  arr.find((valueInner, index) => {
    if (valueInner === value) indexToReturn = index;
    return true;
  });

  return indexToReturn;
};

// build teachers string
export const buildTeachersStr = (
  teachers,
  teachersArr,
  changes,
  currentScreen
) => {
  let i = 0;

  let teachersArrToStr = [];
  for (let teacher of teachersArr) {
    let comma = "";
    let teacherStr;
    let teacherStrNew;
    let newTeacher;
    let currentTeacher = getTeacherById(teachers, teacher)[0];
    teacherStr = <span className="badge-teacher">{currentTeacher.name}</span>;

    if (
      currentScreen === 2 &&
      Object.entries(changes).length !== 0 &&
      changes.voidTeachers &&
      changes.voidTeachers.includes(currentTeacher._id)
    ) {
      let index = getIndexByValue(changes.voidTeachers, currentTeacher._id);
      if (changes.addTeachers) {
        newTeacher = getTeacherById(
          teachers,
          changes.addTeachers[index]._id
        )[0];
        //newTeacher = getTeacherById(teachers, changes.addTeachers[index])[0]
      }
      teacherStr = (
        <span className="badge badge-danger badge-teacher">
          <strike>{currentTeacher.name}</strike>
        </span>
      );

      if (newTeacher) {
        teacherStrNew = (
          <span className="badge badge-success badge-teacher">
            {newTeacher.name}
          </span>
        );
      }
    }

    if (teachersArr.length > i + 1) {
      comma = ",";
    }
    teachersArrToStr.push(teacherStr, teacherStrNew, comma);
    i++;
  }
  return teachersArrToStr;
  /*
    for(let teacher of teachersArr){
        teachersArrToStr.push(getTeacherById(teachers,teacher))
    }
    let  teachersArrToStrMaped = teachersArrToStr.map( (name,key) =>{
        let nameUpdated = <span>{name[0].name}</span>;

        if( changes.length && changes[0].voidTeachers.includes(name[0]._id) ){

            console.log(changes[0])
            nameUpdated = <strike>{name[0].name}</strike>
            let newTeacher = getTeacherById(teachers,name._id)
            console.log(newTeacher)
            nameUpdated += <span>{newTeacher.name}</span>
        }

        if(key !== teachersArrToStr.length - 1){
            nameUpdated += ","
        }

        return nameUpdated
    } )
    return teachersArrToStrMaped;
  */
};

export const getTeacherById = (teachers, teacher) => {
  return teachers.filter((teacherFilter) => {
    return teacherFilter._id === teacher;
  });
};

export const getRoomsName = (rooms) => {
  return rooms.map((room) => {
    return room.name;
  });
};

export const getSubjectName = (subjects, subject) => {
  let currSubject = subjects.filter((subjectFilter) => {
    return subjectFilter._id === subject;
  });
  // console.log(currSubject)
  if (currSubject.length > 0) {
    return currSubject[0].name;
  }
  return '';
};

export function createViewTimeTableTeacher(context) {
  let classTimeTable = [];
  let daysOfWeek = [];
  let newHour;
  let newDay;
  let loopTimes = getHighestHour(context.state.ttGroups);
  let timeDictonary;
  let numOfDays = getNumOfDays(context);
  if (context.state.useSlotLabels) {
    timeDictonary = getClassHoursById(context.state);
  }
  // console.log(loopTimes)
  // console.log(context)
  // build time table

  for (let hours = 0; hours <= loopTimes; hours++) {
    let ttGroup = getLessonByDayAndHourAndTeacher(hours, context.state);

    if (!(hours in classTimeTable)) classTimeTable[hours] = [];

    for (let tt of ttGroup) {


      newHour = "";
      newDay = "";
      let currGroup = getGroupById(tt.group_id, context.state.groups);
      let currentClass = getRoomById(tt.room_id, context.state.rooms)
        ? getRoomById(tt.room_id, context.state.rooms)
        : [];

      if (
        currGroup[0]

      ) {
        if (!(tt.day in classTimeTable[hours])) {
          classTimeTable[hours][tt.day] = [];
        }

        // get changes of specific class
        let changes = getTtSubjects(tt._id, context.state.ttSubjects);
        //console.log(changes)
        if (changes.xDay && changes.xSlot) {
          newHour = changes.xSlot;
          newDay = changes.xDay;

          if (!(newHour in classTimeTable)) classTimeTable[newHour] = [];

          if (!(newDay in classTimeTable[newHour])) {
            classTimeTable[newHour][newDay] = [];
          }

          classTimeTable[newHour][newDay][
            classTimeTable[newHour][newDay].length
          ] = {
            _id: tt._id,
            days: newDay,
            hours: newHour,
            classes: getClassById(context.state.classes, currGroup[0].classes),
            teachers: buildTeachersStr(
              context.state.teachers,
              currGroup[0].teachers,
              changes,
              context.state.currentScreen
            ),
            subject: getSubjectName(
              context.state.subjects,
              currGroup[0].subject
            ),
            room_name: getRoomsName(currentClass),
            changes: changes,
            changedFrom: { hour: hours, day: tt.day },
          };
        }

        classTimeTable[hours][tt.day][classTimeTable[hours][tt.day].length] = {
          _id: tt._id,
          days: tt.day,
          hours: hours,
          classes: getClassById(context.state.classes, currGroup[0].classes),
          teachers: buildTeachersStr(
            context.state.teachers,
            currGroup[0].teachers,
            changes,
            context.state.currentScreen
          ),
          subject: getSubjectName(context.state.subjects, currGroup[0].subject),
          room_name: getRoomsName(currentClass),
          changes: changes,
          changedTo: { hour: newHour, day: newDay },
        };
        // console.dir(newHour)
      }
    }

    // classTimeTable.sort((a, b) => (a.days > b.days) ? 1 : (a.days === b.days) ? ((a.hours > b.hours) ? 1 : -1) : -1 )
  }

  // add and fix non lessond times
  for (let i = 0; i <= loopTimes; i++) {
    for (let a = 0; a <= numOfDays; a++) {
      if (a in classTimeTable[i] === false) {
        classTimeTable[i][a] = [];
      }
    }
  }
  //console.log(classTimeTable)
  return classTimeTable;
}


export function createViewTimeTable(context) {
  let classTimeTable = [];
  let daysOfWeek = [];
  let newHour;
  let newDay;
  let loopTimes = getHighestHour(context.state.ttGroups);
  let timeDictonary;
  let numOfDays = getNumOfDays(context);
  if (context.state.useSlotLabels) {
    timeDictonary = getClassHoursById(context.state);
  }
  // console.log(loopTimes)
  // console.log(context)
  // build time table

  for (let hours = 0; hours <= loopTimes; hours++) {
    let ttGroup = getLessonByDayAndHour(hours, context.state.ttGroups);

    if (!(hours in classTimeTable)) classTimeTable[hours] = [];

    for (let tt of ttGroup) {

      //console.log(tt);
      newHour = "";
      newDay = "";
      let currGroup = getGroupById(tt.group_id, context.state.groups);
      let currentClass = getRoomById(tt.room_id, context.state.rooms)
        ? getRoomById(tt.room_id, context.state.rooms)
        : [];

      if (
        currGroup[0] &&
        currGroup[0].classes.includes(context.state.classId)
      ) {
        if (!(tt.day in classTimeTable[hours])) {
          classTimeTable[hours][tt.day] = [];
        }


        // get changes of specific class
        let changes = getTtSubjects(tt._id, context.state.ttSubjects);
        //console.log(changes)
        if (changes.xDay && changes.xSlot) {
          newHour = changes.xSlot;
          newDay = changes.xDay;

          if (!(newHour in classTimeTable)) classTimeTable[newHour] = [];

          if (!(newDay in classTimeTable[newHour])) {
            classTimeTable[newHour][newDay] = [];
          }

          classTimeTable[newHour][newDay][
            classTimeTable[newHour][newDay].length
          ] = {
            _id: tt._id,
            days: newDay,
            hours: newHour,
            teachers: buildTeachersStr(
              context.state.teachers,
              currGroup[0].teachers,
              changes,
              context.state.currentScreen
            ),
            subject: getSubjectName(
              context.state.subjects,
              currGroup[0].subject
            ),
            room_name: getRoomsName(currentClass),
            changes: changes,
            changedFrom: { hour: hours, day: tt.day },
            name: tt.name
          };
        }

        classTimeTable[hours][tt.day][classTimeTable[hours][tt.day].length] = {
          _id: tt._id,
          days: tt.day,
          hours: hours,
          teachers: buildTeachersStr(
            context.state.teachers,
            currGroup[0].teachers,
            changes,
            context.state.currentScreen
          ),
          subject: getSubjectName(context.state.subjects, currGroup[0].subject),
          room_name: getRoomsName(currentClass),
          changes: changes,
          changedTo: { hour: newHour, day: newDay },
          name: tt.name
        };
        // console.dir(newHour)
      }
    }

    // classTimeTable.sort((a, b) => (a.days > b.days) ? 1 : (a.days === b.days) ? ((a.hours > b.hours) ? 1 : -1) : -1 )
  }

  //console.log(numOfDays);
  // add and fix non lessond times
  for (let i = 0; i <= loopTimes; i++) {
    for (let a = 0; a <= numOfDays; a++) {
      if (a in classTimeTable[i] === false) {
        classTimeTable[i][a] = [];
      }
    }
  }
  //console.log(classTimeTable)
  return classTimeTable;
}

export const getTeacherByIdJoin = (teachers, teacher) => {
  let teachersArr = teachers
    .filter((teacherFilter) => {
      return teacher.includes(teacherFilter._id);
    })
    .map((elem) => elem.name);
  return teachersArr.join(",");
};

export const getNumOfDays = (context) => {
  if (context.state.ttGroups.length > 0) {
    return Math.max.apply(
      Math,
      context.state.ttGroups.map(function (o) {
        return o.day;
      })
    );
  } else {
    return 0;
  }

};

export const getHighestHour = (ttGroup) => {
  return Math.max.apply(
    Math,
    ttGroup.map(function (o) {
      return o.slot;
    })
  );
};

export const getWeekDates = (dateCurr) => {
  let weekStartDay = moment(dateCurr, "DD/MM/YYYY");

  let allWeek = [weekStartDay.format("DD/MM/YYYY")];
  for (let i = 1; i <= 6; i++) {
    allWeek.push(weekStartDay.add(1, "days").format("DD/MM/YYYY"));
  }

  return allWeek;
};

export const getTtSubjects = (TtGroupId, ttSubjects) => {
  let hasCanges = ttSubjects.filter((subject) => {
    return subject.ttGroup_id === TtGroupId;
  });
  if (hasCanges.length) return hasCanges[0];

  return {};
};

export const getRoomNameById = (rooms, room) => {
  return rooms.filter((elem) => room == elem._id).map((elem) => elem.name)[0];
};

export const getClassById = (classes, classer) => {
  let classesArr = classes
    .filter((classFilter) => {
      return classer.includes(classFilter._id);
    })
    .map((elem) => elem.name);
  return classesArr.join(",");
};

export const getCurrentGroupType = (sbjKnds, kind) => {
  let currSbj = sbjKnds.filter((sbjKnd) => {
    return sbjKnd._id === kind;
  });
  // console.log(currSubject)
  return currSbj[0].exId;
};

export const getCurrentGroupTypeName = (sbjKnds, kind) => {
  //console.log('sbjKnds: ', sbjKnds);
  //console.log('kind: ', kind);
  let currSbj = sbjKnds.filter((sbjKnd) => {
    return sbjKnd._id === kind;
  });
  // console.log(currSubject)
  return currSbj[0].name;
};

export const getRoomsList = (rooms, roomsSelected = [], classes, teachers) => {
  let returnRooms = [];
  returnRooms = rooms.map((room) => {
    if (roomsSelected.length > 0) {
      return {
        id: room._id,
        ocupied: classes[0].name + "-" + teachers[0].name,
      };
    }
  });
  return returnRooms[0];
};

export const getDaysOfWeek = (context) => {

  let topDay = getNumOfDays(context);
  let daysOfWeek = [
    "יום ראשון",
    "יום שני",
    "יום שלישי",
    "יום רביעי",
    "יום חמישי",
    "יום שישי",
    "יום שבת",
  ];
  daysOfWeek.splice(0, context.state.firstDay - 1);
  daysOfWeek.length = (topDay + context.state.firstDay) + 1;
  return daysOfWeek;
}

export const daysOfWeek = [
  "יום ראשון",
  "יום שני",
  "יום שלישי",
  "יום רביעי",
  "יום חמישי",
  "יום שישי",
  "יום שבת",
];
